var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 11.25C8.20679 11.25 9.84375 9.61304 9.84375 7.59375C9.84375 5.57446 8.20679 3.9375 6.1875 3.9375C4.16821 3.9375 2.53125 5.57446 2.53125 7.59375C2.53125 9.61304 4.16821 11.25 6.1875 11.25Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9272 4.07356C11.4301 3.93187 11.9575 3.89959 12.474 3.9789C12.9904 4.0582 13.4838 4.24725 13.921 4.53332C14.3582 4.81938 14.729 5.19581 15.0085 5.63725C15.288 6.07869 15.4696 6.5749 15.5411 7.09244C15.6127 7.60999 15.5725 8.13686 15.4233 8.63756C15.274 9.13827 15.0193 9.60119 14.6761 9.99513C14.3329 10.3891 13.9092 10.7049 13.4337 10.9213C12.9582 11.1378 12.4418 11.2498 11.9193 11.2499",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12451 13.8795C1.69554 13.0672 2.45362 12.4043 3.33475 11.9466C4.21588 11.489 5.19418 11.25 6.18707 11.25C7.17996 11.25 8.15828 11.4888 9.03944 11.9464C9.92061 12.404 10.6787 13.0669 11.2498 13.8791",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9194 11.25C12.9124 11.2493 13.8909 11.4878 14.7722 11.9455C15.6534 12.4031 16.4114 13.0664 16.982 13.8791",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.535eda0f070284cd398dab05ba90416d.svg";
export { ForwardRef as ReactComponent };